export const getHelpTextId = (fieldId) => `${fieldId}_help-text`;
